module.exports = __webpack_public_path__ + "img/facebook.84226998.svg";